// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type GoogleSdk = any;

export const googleSdk = (): GoogleSdk =>
  (window as unknown as { google?: GoogleSdk }).google;
export const gapiSdk = (): GoogleSdk =>
  (window as unknown as { gapi?: GoogleSdk }).gapi;

export const GIS_SCRIPT_SRC = "https://accounts.google.com/gsi/client";
export const GAPI_SCRIPT_SRC = "https://apis.google.com/js/api.js";

const FAILED_SCRIPT_ATTR = "data-load-failed";

export const loadGoogleScript = (src: string, ready: () => boolean) =>
  new Promise<void>((resolve, reject) => {
    if (ready()) return resolve();
    const existing = document.querySelector<HTMLScriptElement>(
      `script[src="${src}"]:not([${FAILED_SCRIPT_ATTR}])`,
    );
    if (existing) {
      existing.addEventListener("load", () => resolve());
      existing.addEventListener("error", () => {
        existing.setAttribute(FAILED_SCRIPT_ATTR, "");
        existing.remove();
        reject(new Error(`Failed to load ${src}`));
      });
      return;
    }
    const s = document.createElement("script");
    s.src = src;
    s.async = true;
    s.defer = true;
    s.onload = () => resolve();
    s.onerror = () => {
      s.setAttribute(FAILED_SCRIPT_ATTR, "");
      s.remove();
      reject(new Error(`Failed to load ${src}`));
    };
    document.body.appendChild(s);
  });
